import React, { ReactNode } from "react";

import { Ds } from "@accurx/design";

import { StyledLoginBackButton } from "./Login.styles";

export const LoginBackButton = ({
    children,
    onClick,
}: {
    children: ReactNode;
    onClick: () => void;
}) => {
    return (
        <StyledLoginBackButton appearance="tertiary" onClick={onClick}>
            <Ds.Button.Icon name="ArrowTail" rotate="270" />
            {children}
        </StyledLoginBackButton>
    );
};
